import { AmplitudeInteractionChannel } from 'Src/models/Amplitude/InteractionChannels';
import { getDeviceType } from 'Utils/getDeviceType';

export const getInteractionChannel = () => {
  const device = getDeviceType();

  return device === 'mobile'
    ? AmplitudeInteractionChannel.WEB_MOBILE : AmplitudeInteractionChannel.WEB_DESKTOP;
};
